var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertActivityReport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03702 3.6321L5.23702 2.83105L3.83702 4.23288L3.43702 3.83236L2.63702 4.53327L3.93702 5.83497L6.03702 3.6321Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.911 3.66913H7.211V4.77056H11.911V3.66913Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03702 7.41905L5.23702 6.71814L3.83702 8.01983L3.43702 7.61931L2.63702 8.42036L3.83702 9.62192L6.03702 7.41905Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.911 7.41803H7.211V8.51946H11.911V7.41803Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.2741L5.2 10.473L3.8 11.8748L3.3 11.3742L2.5 12.1752L3.8 13.4769L6 11.2741Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.511 18.5515H0V0.528076H14.59V9.33955H13.577V1.54039H1.013V17.5392H8.513L8.511 18.5515Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.59 12.4436H13.59V18.5516H14.59V12.4436Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.088 15.047H10.988V16.0483H17.088V15.047Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.911 11.1679H7.211V12.2693H11.911V11.1679Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertActivityReport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert-activity-report.03a5d0b661458e8050058a9c49ca9e01.svg";